import './blog-section.scss';

export default () => {
	recall( '#load-more', '.js-articles-item' );

	function recall ( btn, blog ) {
		let nextBtn = document.querySelector( btn );

		nextBtn && nextBtn.addEventListener( 'click', function ( e ) {
			e.preventDefault();
			let nextPage = nextBtn.getAttribute( 'href' );

			fetch( nextPage )
				.then( ( response ) => response.text() )
				.then( ( html ) => {
					let parser = new DOMParser();
					let doc = parser.parseFromString( html, 'text/html' );
					let articles = doc.querySelector( '#articles' );

					let articlesContainer = document.createElement( 'div' );

					articlesContainer.id = 'articles2';
					articlesContainer.style.display = 'none';
					articlesContainer.append( ...Array.from( articles.childNodes ) );

					document.querySelector( '#articles' ).append( articlesContainer );

					let articleNew = document.querySelector( '#articles2' );

					articleNew.replaceWith( ...Array.from( articleNew.childNodes ) );

					fetch( nextPage )
						.then( ( response ) => response.text() )
						.then( ( html ) => {
							let parser = new DOMParser();
							let doc = parser.parseFromString( html, 'text/html' );
							let nextBtnContainer = doc.querySelector( btn );

							if ( nextBtnContainer ) {
								nextBtn.closest( 'div' ).innerHTML = nextBtnContainer.outerHTML;
								recall( btn, blog );
							} else {
								nextBtn.remove();
							}
						} );
				} );
		} );
	}
};
